/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeHealthRow
 */
export interface InitiativeHealthRow {
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    ownerUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    lifecyclePhase?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    targetMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    compositeDesigned?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    compositeOperational?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    compositeValidated?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    operationalGap?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeHealthRow
     */
    operationalStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    operationalScore30dAgo?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    operationalDelta30d?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    completionRate30d?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof InitiativeHealthRow
     */
    overdueByCadenceTier?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof InitiativeHealthRow
     */
    overdueTotal?: number;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeHealthRow
     */
    ownerLastActiveAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeHealthRow
     */
    targetDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InitiativeHealthRow
     */
    pastTargetDate?: boolean;
}

/**
 * Check if a given object implements the InitiativeHealthRow interface.
 */
export function instanceOfInitiativeHealthRow(value: object): value is InitiativeHealthRow {
    return true;
}

export function InitiativeHealthRowFromJSON(json: any): InitiativeHealthRow {
    return InitiativeHealthRowFromJSONTyped(json, false);
}

export function InitiativeHealthRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeHealthRow {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'status': json['status'] == null ? undefined : json['status'],
        'lifecyclePhase': json['lifecyclePhase'] == null ? undefined : json['lifecyclePhase'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'compositeDesigned': json['compositeDesigned'] == null ? undefined : json['compositeDesigned'],
        'compositeOperational': json['compositeOperational'] == null ? undefined : json['compositeOperational'],
        'compositeValidated': json['compositeValidated'] == null ? undefined : json['compositeValidated'],
        'operationalGap': json['operationalGap'] == null ? undefined : json['operationalGap'],
        'operationalStatus': json['operationalStatus'] == null ? undefined : json['operationalStatus'],
        'operationalScore30dAgo': json['operationalScore30dAgo'] == null ? undefined : json['operationalScore30dAgo'],
        'operationalDelta30d': json['operationalDelta30d'] == null ? undefined : json['operationalDelta30d'],
        'completionRate30d': json['completionRate30d'] == null ? undefined : json['completionRate30d'],
        'overdueByCadenceTier': json['overdueByCadenceTier'] == null ? undefined : json['overdueByCadenceTier'],
        'overdueTotal': json['overdueTotal'] == null ? undefined : json['overdueTotal'],
        'ownerLastActiveAt': json['ownerLastActiveAt'] == null ? undefined : (new Date(json['ownerLastActiveAt'])),
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'pastTargetDate': json['pastTargetDate'] == null ? undefined : json['pastTargetDate'],
    };
}

export function InitiativeHealthRowToJSON(json: any): InitiativeHealthRow {
    return InitiativeHealthRowToJSONTyped(json, false);
}

export function InitiativeHealthRowToJSONTyped(value?: InitiativeHealthRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'ownerUserId': value['ownerUserId'],
        'status': value['status'],
        'lifecyclePhase': value['lifecyclePhase'],
        'capabilityDomain': value['capabilityDomain'],
        'targetMaturity': value['targetMaturity'],
        'compositeDesigned': value['compositeDesigned'],
        'compositeOperational': value['compositeOperational'],
        'compositeValidated': value['compositeValidated'],
        'operationalGap': value['operationalGap'],
        'operationalStatus': value['operationalStatus'],
        'operationalScore30dAgo': value['operationalScore30dAgo'],
        'operationalDelta30d': value['operationalDelta30d'],
        'completionRate30d': value['completionRate30d'],
        'overdueByCadenceTier': value['overdueByCadenceTier'],
        'overdueTotal': value['overdueTotal'],
        'ownerLastActiveAt': value['ownerLastActiveAt'] == null ? undefined : ((value['ownerLastActiveAt']).toISOString()),
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'pastTargetDate': value['pastTargetDate'],
    };
}

